import { render } from "./manager.vue?vue&type=template&id=3edc9bf6&scoped=true"
import script from "./manager.vue?vue&type=script&lang=js"
export * from "./manager.vue?vue&type=script&lang=js"

import "./manager.vue?vue&type=style&index=0&id=3edc9bf6&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3edc9bf6"]])

export default __exports__